import React, { useEffect, useState } from "react";
import "./SelectField.css";
import { useRef } from "react";

const SelectEmailTemplate = ({
  options,
  emailTemplates,
  handleEmailTemplateSelect,
  handleBlurField,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const selectRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  // Close the dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const selectedIndex = e.target.selectedIndex;
    const selectedEmailTemplate = emailTemplates[selectedIndex - 1];
    handleEmailTemplateSelect({ ...selectedEmailTemplate });
  };

  return (
    <>
      <div className="custom-select" ref={selectRef}>
        <div className="custom-select__control" onClick={toggleDropdown}>
          {selectedOption ? selectedOption.label : "Select an option"}
          <span className={`arrow ${isOpen ? "open" : ""}`}>&#9662;</span>
        </div>
        {isOpen && (
          <div className="custom-select__menu">
            {options.map((option) => {
              if (option.value === "create") {
                return (
                  <div
                    key={option.value}
                    className="custom-select__option"
                    data-bs-toggle="modal"
                    data-bs-target="#emailTemplateModal"
                    onClick={() => handleOptionClick(option)}
                  >
                    {option.label}
                  </div>
                );
              } else {
                return (
                  <div
                    key={option.value}
                    className="custom-select__option"
                    onClick={() => handleOptionClick(option)}
                  >
                    {option.label}
                  </div>
                );
              }
            })}
          </div>
        )}
      </div>
      {selectedOption && selectedOption.value === "existing" ? (
        <>
          <div className="suf_inpfield mt-2">
            <label>Existing Email Templates:</label>
            <select
              name=""
              id=""
              className="existing_form_select"
              onChange={handleChange}
              // onBlur={handleBlurField}
            >
              <option value="" className="existing_form_select_option">
                Select email template
              </option>
              {emailTemplates.map((email, index) => (
                <option key={index} className="existing_form_select_option">
                  {email.template_name}
                </option>
              ))}
            </select>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default SelectEmailTemplate;
